import useNoteSummary from "../../../hooks/use-note-summary";
import StatCard from "../../../components/StatCard";
import { StatSummary } from "../../../components/StatSummary";
import ChartCard from '../../../components/chart/chart-card';
import Grid from "@mui/material/Grid";
import DoughnutChart from '../../../components/chart/doughnut-chart';
import { NoteStatus } from '../../../shared/enums';
import { ChecklistIcon } from "../../../shared/icons";

export const getColorForNoteStatus = (status: NoteStatus) => {
    switch (status) {
        case NoteStatus.OPEN:
            return '#FFBB28';
        case NoteStatus.COMPLETED:
            return '#00C49F';
        default:
            return '#8884d8';
    }
}

const NoteSummary = () => {
    const noteSummary = useNoteSummary();

    return (
        <div>
            {noteSummary &&
                <>
                    <StatSummary>
                        <StatCard title="Total Notes" value={noteSummary?.total.toString()} icon={ChecklistIcon} />
                        <StatCard title="Due Today" value={noteSummary?.dueTodayCount.toString()} icon={ChecklistIcon} />
                        <StatCard title="Open Items" value={noteSummary?.openCount.toString()} icon={ChecklistIcon} />
                        <StatCard title="Overdue Items" value={noteSummary?.overdueCount.toString()} icon={ChecklistIcon} />
                        {/* <StatCard title="Expired" value={noteSummary?.expiredCount.toString()} icon={HourglassTopIcon} /> */}
                    </StatSummary>
                    <Grid container direction="row" justifyContent="flex-start">
                        <Grid size={{ lg: 3, md: 6, sm: 12, xs: 12 }}>
                            <ChartCard><DoughnutChart data={noteSummary.countByStatus.map(item => { return { name: item.key, value: item.value, color: getColorForNoteStatus(item.key as NoteStatus) } })} label='Status' /></ChartCard>
                        </Grid>
                    </Grid>
                </>
            }
        </div>
    )
}

export default NoteSummary;